import { request } from '../../utils/request';

export const getContentArticleList = ({
  type,
  orderStrategy,
  pageSize,
  pageNo,
}: {
  type: string[];
  orderStrategy: string;
  pageSize: number;
  pageNo: number;
}) => {
  return request('https://dropshipping.alibaba.com/saas/ajax/helpcenter/searchContentArticleList', {
    method: 'GET',
    query: {
      type,
      orderStrategy,
      pageNo,
      pageSize,
    },
  });
};
